import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/cupones';
import CuponCrear from './CuponCrear';


const ms2p = (state) => {
    return {
        ...state.cupones,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CuponCrear);
